import Hero from "@/components/home/Hero";
import Marquee from "@/components/home/Marquee";
import TrustBanner from "@/components/home/TrustBanner";
import Services from "@/components/home/Services";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <TrustBanner />
      <Services />
    </div>
  );
}
